import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Environment } from 'src/environments/environment';

import { PhosphateLegalWorkingCoefficient } from '../models';

@Injectable({
  providedIn: 'root',
})
export class PhosphateLegalWorkingCoefficientService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl =
    this.env.APIM_BASE_URL + '/arable-service/phosphatelegalworkingcoefficient';

  getPhosphateLegalWorkingCoefficientByCropAidIdAndYear(cropAidId: number, year: number) {
    return this.http.get<PhosphateLegalWorkingCoefficient>(this.baseUrl + `/${year}/${cropAidId}`);
  }
}
